export default "/images/f9df787d45aaa60295e67dbd6b7ff8e0.avif";